import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "/logo.png";

/**
 * BrickDailyDeals official logo (round badge with bricks + price tag).
 * The logo already contains the brand wordmark, so we don't render extra text alongside.
 */
export default function Logo({ size = "md", withText = true }) {
  const sz = size === "lg" ? 72 : size === "sm" ? 40 : 52;
  return (
    <Link
      to="/"
      data-testid="logo-link"
      aria-label="BrickDailyDeals — Home"
      className="flex items-center gap-3 select-none group"
    >
      <img
        src={LOGO_URL}
        alt="BrickDailyDeals"
        width={sz}
        height={sz}
        className="shrink-0 transition-transform group-hover:scale-[1.04]"
        style={{
          width: sz,
          height: sz,
          objectFit: "contain",
          filter: "drop-shadow(0 6px 20px rgba(251,213,28,0.35))",
        }}
      />
      {withText && (
        <div className="leading-none hidden sm:block">
          <div className="font-display text-[20px] tracking-tight text-white">
            Brick<span className="text-brand-grad">Daily</span>Deals
          </div>
          <div className="font-mono-bdd text-[9px] uppercase tracking-[0.28em] text-[#6e7896] mt-1">
            Offerte set di costruzioni
          </div>
        </div>
      )}
    </Link>
  );
}
